import React from "react";

const SideBarInfo = ({ info_key, value, key_width="auto" }) => {
    return (
        <div className="flex-row">
            <span className="font-medium semibold light" style={{width: key_width}}>{info_key + ":"}</span>
            <span className="font-medium light">{value}</span>
        </div>
    );
};
export default SideBarInfo;

